import { SearchBox } from "@cpj-ai/panel-npm-package";

import {
  PostHiringCompleteAssessmentCTACard,
  PostHiringReportDetailCard,
  postHiringSearchBoxFormConfig,
} from "@cpj-ai/panel-npm-package";

const PerformanceReportTabContent = () => {
  return (
    <div>
      <SearchBox inputConfigs={postHiringSearchBoxFormConfig} filterItems={() => {}} formGridSize={10} />
      <div className="mt-5 flex flex-col gap-5">
        <PostHiringCompleteAssessmentCTACard />
        <PostHiringReportDetailCard />
      </div>
    </div>
  );
};

export default PerformanceReportTabContent;
